// import React, { useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// const ConnectionPaymentWebView = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const paymentUrl = location.state?.paymentUrl;
//   console.log("open url", paymentUrl);

//   useEffect(() => {
//     const handleMessage = (event) => {
//       console.log("Message origin:", event.origin);
//       console.log("Message from payment iframe:", event.data);

//       if (event.origin !== "https://connecttovow.com") return;

//       const data = event.data;
//       console.log("connectionPaymentWebView________", data);
//       if (data === "payment_success") {
//         console.log("Payment successful");
//         setTimeout(() => {
//           navigate("/Sidebar/Subscription");
//         }, 1000);
//       } else {
//         console.log("Payment failed or other message");
//         setTimeout(() => {
//           navigate("/SubscriptionPlans");
//         }, 1000);
//       }
//     };

//     window.addEventListener("message", handleMessage);
//     return () => {
//       window.removeEventListener("message", handleMessage);
//     };
//   }, [navigate]);

//   if (!paymentUrl) {
//     return <div>Error: Payment URL not provided.</div>;
//   }

//   return (
//     <div style={{ height: "100vh" }}>
//       <iframe
//         src={paymentUrl}
//         title="Payment"
//         style={{ width: "100%", height: "100%", border: "none" }}
//         allow="payment"
//         sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
//       />
//     </div>
//   );
// };

// export default ConnectionPaymentWebView;
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ConnectionPaymentWebView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const paymentUrl = location.state?.paymentUrl;

  useEffect(() => {
    const handleMessage = (event) => {
      console.log("Message from iframe:", event.data);

      if (
        event.data === "payment_success" ||
        event.data?.type === "payment_success"
      ) {
        console.log("Payment succeeded via event");
        navigate("/Sidebar/Subscription");
      } else {
        console.log("Payment failed or other message");
        navigate("/SubscriptionPlans");
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  if (!paymentUrl) {
    return <div>Error: Payment URL not provided.</div>;
  }

  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src={paymentUrl}
        title="Payment"
        style={{ width: "100%", height: "100%", border: "none" }}
        allow="payment"
      />
    </div>
  );
};

export default ConnectionPaymentWebView;
